export enum ViewMode {
    Supplier = 'Supplier',
    MultipleSupplier = 'Multiple Supplier',
    Buyer = 'Buyer',
    MultipleTenant = 'Multiple Tenant',
    MultipleSupplierAndTenant = 'Multiple Supplier and Tenant',
}

export const SupplierViewModes = [
    ViewMode.Supplier,
    ViewMode.MultipleSupplier,
    ViewMode.MultipleTenant,
    ViewMode.MultipleSupplierAndTenant,
];
